import configApi from "./config-api.json";
import configDev from "./config-dev.json";
import config from "./config.json";

export default {
    ...config,
    ...(process.env.REACT_APP_NODE_ENV === "production" ? configApi : configDev),
}